import api from './api';

export interface LocationInput {
  address?: string;
  lat?: number;
  lng?: number;
}

export interface CompareRouteRequest {
  origin: LocationInput;
  destination: LocationInput;
  avoid_tolls?: boolean;
}

export interface StateMileage {
  state: string;
  miles: number;
}

export interface RouteCoord {
  lat: number;
  lng: number;
}

export interface GoogleResult {
  distance_miles: number | null;
  duration_minutes: number | null;
  route_polyline: string | null;
  error: string | null;
}

export interface TrimbleResult {
  distance_miles: number | null;
  duration_minutes: number | null;
  toll_cost: number | null;
  state_mileage: StateMileage[];
  route_coords: RouteCoord[];
  error: string | null;
}

export interface CompareRouteResponse {
  origin_resolved: { lat: number; lng: number; formatted_address?: string } | null;
  destination_resolved: { lat: number; lng: number; formatted_address?: string } | null;
  google: GoogleResult;
  trimble: TrimbleResult;
}

export interface CMSLocation {
  recno: number;
  lname: string;
  lcity: string | null;
  lstate: string | null;
  lat: number;
  lng: number;
}

class TrimbleService {
  async compareRoute(request: CompareRouteRequest): Promise<CompareRouteResponse> {
    const response = await api.post<CompareRouteResponse>('/trimble/compare-route', request);
    return response.data;
  }

  async getCmsLocations(): Promise<CMSLocation[]> {
    const response = await api.get<CMSLocation[]>('/trimble/cms-locations');
    return response.data;
  }
}

export default new TrimbleService();
